import React from 'react';
//
//
// const top = {
//     top: '3717px'
// }

function CommercialRowOne() {
    return (
        <div className="commercialBlack">
            <div className="CommercialRowOne firstGrid">
                <img className="CommImageOne" src="Images/commercial/M2.jpg" alt="Ovaj"/>
                <img className="CommImageTwo" src="Images/commercial/Rossetto2b_1.jpg" alt="Ovaj"/>
                <img className="CommImageThree" src="Images/commercial/Social_02.jpg" alt="Ovaj"/>
                <img className="CommImageFour" src="Images/commercial/Op_1.jpg" alt="Ovaj"/>
            </div>
            <div className="CommercialRowOne">
                <img className="CommImageFive" src="Images/commercial/5_Def.jpg" alt="Ovaj"/>
                <img className="CommImageSix" src="Images/commercial/Eye4.jpg" alt="Ovaj"/>
                <img className="CommImageSeven" src="Images/commercial/Malo_05.jpg" alt="Ovaj"/>
            </div>

            <div className="CommercialText">
                <svg id="commercial__svg__one" width="867" height="1001" viewBox="0 0 867 1001" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0.554291 250.539L433.5 0.57735L866.446 250.539V750.461L433.5 1000.42L0.554291 750.461L0.554291 250.539Z" stroke="white" stroke-opacity="0.22"/>
                </svg>
                <svg id="commercial__svg__two" width="810" height="934" viewBox="0 0 810 934" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M3.56613 235.232L405 3.4641L806.434 235.232V698.768L405 930.536L3.56613 698.768L3.56613 235.232Z" stroke="white" stroke-opacity="0.22" stroke-width="6"/>
                </svg>


                <div>
                    <h1>TAILER CREATIVE</h1>
                    <h1><span>IMMAGINE</span></h1>
                    <h5>Tailer fornisce un contributo completo ad i brand che ci contattano per valorizzare i propri
                        prodotti, si differenzia dai competitor per la ricerca creativa e la sensibilità di lettura del
                        prodotto. Lo studio può lavorare in collaborazione con il tema Marketing del brand, o
                        contribuire
                        con servizi di consulenza creativa. Le attività dello studio sono organizzate per la creazione
                        di
                        immagini video e fotografiche destinate al modo social advertising e</h5>
                </div>
            </div>
            <div className="CommercialRowOne">
                <img className="CommImageSecondOne" src="Images/commercial/Mesauda_1.jpg" alt="Ovaj"/>
                <div className="gridSystem">
                    <img className="CommImageSecondTwo" src="Images/commercial/H3.jpg" alt="Ovaj"/>
                    <img className="CommImageSecondThree" src="Images/commercial/Profumo1.jpg" alt="Ovaj"/>
                </div>
                <img className="CommImageSecondFour" src="Images/commercial/B1.jpg" alt="Ovaj"/>
            </div>
            <div className="CommercialRowOne Height">
                <div className="gridSystem">
                    <img className="CommImageSecondFive" src="Images/commercial/Malo_17.jpg" alt="Ovaj"/>
                    <img className="CommImageSecondEight" src="Images/commercial/Box_Penne_2800.jpg" alt="Ovaj"/>
                </div>
                <div className="gridSystem">
                    <img className="CommImageSecondSix" src="Images/commercial/Radiance_2.jpg" alt="Ovaj"/>
                    <img className="CommImageSecondNine" src="Images/commercial/Aqua_1.jpg" alt="Ovaj"/>
                </div>
                <div className="gridSystem">
                    <img className="CommImageSecondSeven" src="Images/commercial/Medavita_Adv_C.jpg" alt="Ovaj"/>
                </div>
            </div>

            <div className="noMargin__CommercialInfo">
                <div className="svg__row">
                    <svg width="482" height="856" viewBox="0 0 482 856" fill="none"
                         xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M-305.994 456.441L-131.354 155.009L217.013 155.536L390.741 457.494L216.101 758.926L-132.267 758.399L-305.994 456.441Z"
                            stroke="#F3F3F3" stroke-width="6"/>
                    </svg>
                    {/*<svg id="svg__two" width="515" height="890" viewBox="0 0 515 890" fill="none"*/}
                    {/*     xmlns="http://www.w3.org/2000/svg">*/}
                    {/*    <path*/}
                    {/*        d="M-334.448 489.93L-145.48 163.768L231.468 164.339L419.448 491.07L230.48 817.231L-146.468 816.661L-334.448 489.93Z"*/}
                    {/*        stroke="#BEBEBE"/>*/}
                    {/*</svg>*/}
                </div>
                <div>
                    <div className="logoColorDiv">
                        <img className="logoColor" src="Images/logoColor.png" alt="Tailer Logo"/>
                    </div>
                    <div className="CommercialInfoText">
                        <h5>Lorem ipsun dolor sit ament, consectur ament elite.
                            <br/>
                            Ust de labore aqua aliqua</h5>
                        <h6>Office: + 1 (111) 11-11-11</h6>
                        <h6>example@gmail.com</h6>
                    </div>
                </div>
                <div id="svg__row__right">
                    {/*<svg id="svg__first" width="584" height="890" viewBox="0 0 584 890" fill="none"*/}
                    {/*     xmlns="http://www.w3.org/2000/svg">*/}
                    {/*    <path*/}
                    {/*        d="M95.5522 489.93L284.52 163.768L661.468 164.339L849.448 491.07L660.48 817.231L283.532 816.661L95.5522 489.93Z"*/}
                    {/*        stroke="#BEBEBE"/>*/}
                    {/*</svg>*/}
                    <svg width="552" height="856" viewBox="0 0 552 856" fill="none"
                         xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M92.0056 456.441L266.646 155.009L615.013 155.536L788.741 457.494L614.101 758.926L265.733 758.399L92.0056 456.441Z"
                            stroke="#F3F3F3" stroke-width="6"/>
                    </svg>
                </div>
            </div>

            <div className="CommercialFooter">
                <img src="Images/tech/L_D_2.jpg" alt="Ovaj"/>
                <img src="Images/tech/L_D_5.jpg" alt="Ovaj"/>
                <img src="Images/tech/L_D_6.jpg" alt="Ovaj"/>
                <img src="Images/tech/L_D_6b.jpg" alt="Ovaj"/>
            </div>
        </div>
    )
}

export default CommercialRowOne;
